import {filter} from "lodash";

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy]?.toLowerCase() < a[orderBy]?.toLowerCase()) {
    return -1;
  }
  else {
    return 1;
  }
  // return 0;
}

export function getComparator (order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function applySortFilter (array, comparator, query, filterBy) {
  let stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  stabilizedThis = stabilizedThis.map((el) => el[0]);
  if (query) {
    return filter(stabilizedThis, (predicate) => predicate[filterBy].toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis;
}
